const NAME = "ORGANIZATION_STRUCTURE";

export default NAME;
